//@service
import { bind, RepositoryInterface } from '@/service/utils'
export const fileManagementService = {
  get attachmentTempRepository() {
    return bind(() => import('./attachmentTemp.repo'), RepositoryInterface);
  },
  get attachmentFilesRepository() {
    return bind(() => import('./attachmentFiles.repo'), RepositoryInterface);
  },
  get attachmentRepository() {
    return bind(() => import('./attachment.repo'), RepositoryInterface);
  },
}